// =====================================================================
// Spinner, Lucide Loader2 icon with a CSS spin animation. Used inside
// buttons and the boot screen.
// =====================================================================

import { Loader2 } from "lucide-react";

export default function Spinner({ size = 14, className = "" }) {
  return (
    <Loader2
      size={size}
      strokeWidth={2}
      className={`lm-spinner ${className}`}
      aria-hidden="true"
    />
  );
}
